import { Component, ViewChild } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ShareholderService } from '@appShared/services/shareholder.service';
import { AppFacade } from '@appShared/services/app.facade';
import { IProfile } from '@appShared/interfaces/[Interface-based]/profile.interface';
import { SimpleModalComponent } from '@appShared/components/simple-modal.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
   styles: ['.logo { width: 450px; }'],
   imports: [FormsModule, AsyncPipe, SimpleModalComponent]
})
export class HomeComponent {
   @ViewChild(SimpleModalComponent) ssnModal: SimpleModalComponent
  userProfile: IProfile;
  isAdminOnlyMode$: Observable<boolean>;
  stockPlanUri$: Observable<string>;
  pin: string;

  constructor(
    private _appFacade: AppFacade,
    private _shareholderService: ShareholderService,
    private _router: Router
  ) {
    this._appFacade.userProfile$
      .pipe(take(1))
      .subscribe(userProfile => (this.userProfile = userProfile));

    this.isAdminOnlyMode$ = this._appFacade.isAdminOnlyMode$;
    this.stockPlanUri$ = this._appFacade.stockPlanUri$;
  }

  /*
   * private methods
   * */

  /*
   * public methods
   * */

  viewStockPlan(): void {
    this._shareholderService
      .getShareholder(this.pin)
      .then(shareholder => {
        // if (!shareholder) {
        //  this._commonService.messageUser(
        //    `ID entered doesn't match for<br/>logged in user: '${
        //      this._userProfile.displayName
        //    }'`,
        //    'Identification # Mismatch',
        //    ToastrType.error
        //  );
        // } else {
        this._appFacade.setHasVerifiedSSN();

        if (this.userProfile.hasSubordinates) {
          this._router.navigate(['shareholders']);
        } else {
          this._shareholderService.generatePlanPdf(shareholder);
        }
      })
      .catch(err => {
        /* Do Nothing */
        console.log(err);
      });
   }

   showSSNInfoModal() {
      this.ssnModal?.openModal()
   }
}
